import React from "react";
import styled from "styled-components";
import Icons from "../../../Icons";
import Badge from "../../../Badge";
import ProjectTitle from "../ProjectTitle";
import ProjectSection from "../ProjectSection";
import ProjectSectionSkills from "../ProjectSectionSkills";
import ProjectDescription from "../ProjectDescription";
import ProjectHeroImage from "../ProjectHeroImage";
import Image from "../../../../img/guru-guides.png";
import Links from "../../../Links";

const MuiProjectSection = styled(ProjectSection)`
  background: #2e2e2e;
`;

const Link = styled(Links)`
  color: white;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  &:hover,
  &:focus {
    color: white;
    border-bottom: none;
  }
  &:focus {
    outline-color: white;
  }
`;

const Button = styled(Links)`
  display: block;
  background-color: rgba(0, 0, 0, 0.05);
  display: inline-block;
  text-align: center;
  color: white;
  height: auto;
  text-decoration: none;
  padding: 0px 1.5em;
  border-radius: 3.125em;
  line-height: 3;
  box-shadow: 0 1px 1px 0px rgba(0, 0, 0, 0.5), 0 -1px 0 0 rgba(255, 255, 255, 0.1);
  border-bottom: none;
  font-size: var(--font-size-text-small);
  &:hover,
  &:active {
    background-color: rgba(0, 0, 0, 0.3);
    color: #ffeb3b;
  }
  &:visited {
    color: white;
  }
  &:focus {
    outline-color: white;
  }
`;

const ButtonGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-content: center;
  gap: var(--spacing-small);
  margin-bottom: var(--spacing-large);

  @media (min-width: 500px) {
    grid-template-columns: auto auto auto;
  }
`;

function Guides() {
  return (
    <MuiProjectSection>
      <ProjectTitle title="Guru Guides" tag="2025" />
      <ProjectSectionSkills>
        <Badge small title="UI Design">
          <Icons type="rgba-small" />
        </Badge>
        <Badge small title="HTML">
          <Icons type="html-small" />
        </Badge>
        <Badge small title="CSS">
          <Icons type="css-small" />
        </Badge>
        <Badge small title="React">
          <Icons type="react-small" />
        </Badge>
        <Badge small title="UX Design">
          <Icons type="ux-small" />
        </Badge>
        <Badge small title="Agents & AI">
          <Icons type="ai-small" />
        </Badge>
      </ProjectSectionSkills>
      <ProjectDescription>
        <Link href="https://gurusuite.xyz/guides" target="_blank" color="white">
          Guru Guides
        </Link>{" "}
        is a free tool that helps teams document and share design system guidelines directly in Figma or via the web.
        It’s designed to increase engagement during the design process by reducing context switching and keeping
        guidance close at hand, so designers can stay focused and maintain consistency as teams scale.
      </ProjectDescription>

      <ButtonGroup>
        <Button href="https://www.figma.com/community/plugin/1471341082690554711" target="_blank" color="white">
          Install Plugin
        </Button>

        <Button href="https://guides.gurusuite.xyz" target="_blank" color="white">
          View Website
        </Button>

        <Button href="https://michaeltrilford.co.nz/case-studies#guidelines" color="white">
          Case Study
        </Button>
      </ButtonGroup>

      <ProjectHeroImage src={Image} desktop lazy />
    </MuiProjectSection>
  );
}

export default Guides;
